import React from 'react'
import { Link } from 'react-router-dom'
import enabledDashboardIcon from '../images/enabledDashboardIcon.svg'
import EnabledHorizontalMenuIcon from './EnabledHorizontalMenuIcon'
import EnabledFullHorizontalMenuIcon from './EnabledFullHorizontalMenuIcon'
import EnabledCriticalHorizontalMenuIcon from './EnabledCriticalHorizontalMenuIcon'
import DisabledHorizontalMenuIcon from './DisabledHorizontalMenuIcon'
import disabledDashboardIcon from '../images/disabledDashboardIcon.svg'
import enabledHorizontalAllIcon from '../images/enabledHorizontalAllIcon.svg'
import disabledHorizontalAllIcon from '../images/disabledHorizontalAllIcon.svg'
import enabledVehicleIcon from '../images/enabledVehicleIcon.svg'
import disabledVehicleIcon from '../images/disabledVehicleIcon.svg'
import enabledFullIcon from '../images/enabledFullIcon.svg'
import disabledFullIcon from '../images/disabledFullIcon.svg'
import enabledCriticalIcon from '../images/enabledCriticalIcon.svg'
import disabledCriticalIcon from '../images/disabledCriticalIcon.svg'

class HorizontalDashboardMenuComponent extends React.Component {
  checkDashboardTab () {
    if (this.props.enabled === 'dashboard') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledDashboardIcon}
          label='Dashboard'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledDashboardIcon}
        label='Dashboard'
      />
    )
  }

  checkAllTab () {
    if (this.props.enabled === 'all') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledHorizontalAllIcon}
          label='Tout'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledHorizontalAllIcon}
        label='Tout'
      />
    )
  }

  checkVehicleTab () {
    if (this.props.enabled === 'vehicle') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledVehicleIcon}
          label='Mes véhicules'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledVehicleIcon}
        label='Mes véhicules'
      />
    )
  }

  checkFullTab () {
    if (this.props.enabled === 'full') {
      return (
        <EnabledFullHorizontalMenuIcon
          img={enabledFullIcon}
          label='Plein'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledFullIcon}
        label='Plein'
      />
    )
  }

  checkCriticalVolumeTab () {
    if (this.props.enabled === 'criticalVolume') {
      return (
        <EnabledCriticalHorizontalMenuIcon
          img={enabledCriticalIcon}
          label='Volume critique'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledCriticalIcon}
        label='Volume critique'
      />
    )
  }

  render () {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <Link style={styles.link} to='dashboard'>
            {this.checkDashboardTab()}
          </Link>
          <Link style={styles.link} to='all-report'>
            {this.checkAllTab()}
          </Link>
          {/* <Link style={styles.link} to='vehicle'>
            {this.checkVehicleTab()}
          </Link> */}
          <Link style={styles.link} to='full'>
            {this.checkFullTab()}
          </Link>
          <Link style={styles.link} to='critival-volume'>
            {this.checkCriticalVolumeTab()}
          </Link>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%'
  },
  content: {
    top: '0px',
    margin: '0px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    marginLeft: '14px',
    paddingRight: '14px',
    height: '69px',
    borderColor: '#272C30'
  },
  icon: {
    marginTop: '1px',
    width: '38px',
    height: '40px'
  },
  enabledSection: {
    top: '0px',
    margin: '0px 0px 0px -3px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    width: '74px',
    height: '68px',
    float: 'left',
    borderColor: '#4880FF'
  },
  disabledSection: {
    width: '84px',
    height: '68px',
    float: 'left'
  },
  enabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#4880FF'
  },
  disabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#A6B9C8'
  },
  link: {
    textDecoration: 'none'
  }

}

export default HorizontalDashboardMenuComponent
